import { createKyCacheHook } from '@tsyl/radon'

import type { BufferCalculationType, WeatherTypeData } from '@/types/api/Calculations'
import { dangerCategoryKey } from '@/utils/dangerCategory'

import ky from './httpService'

const cacheHook = createKyCacheHook()
const URI = 'api/calculations/calculationtype'

export const getCalculationTypes = async (): Promise<WeatherTypeData[]> => {
  const weatherTypes: WeatherTypeData[] = [
    {
      id: '079a31c7-21cd-432f-b282-69ab76554a1a',
      name: 'domain.fields.sfdi',
      initials: 'domain.fields.sfdiInitials',
      icon: 'mdi-pine-tree-fire',
      colors: []
    },
    {
      id: '44394d7d-8f6d-4557-9d50-f18444792453',
      name: 'domain.fields.erc',
      initials: 'domain.fields.ercInitials',
      icon: 'mdi-water-thermometer',
      colors: []
    },
    {
      id: 'b420c047-c403-4632-9e27-b27462eeca31',
      name: 'domain.fields.bi',
      initials: 'domain.fields.biInitials',
      icon: 'mdi-tailwind',
      colors: []
    }
  ]
  // const allTypes: BufferCalculationType[] = await ky.get(URI).json()
  const allTypes: BufferCalculationType[] = await ky.get(URI, { hooks: cacheHook('session') }).json()
  for (let i = 0; i < weatherTypes.length; i++) {
    weatherTypes[i].colors = allTypes
      .filter((x) => x.calculationCategory.id === weatherTypes[i].id)
      .map((x) => {
        return {
          color: x.color ?? 'UNDEFINED',
          value: x.displayOrder,
          order: x.displayOrder,
          label: dangerCategoryKey(x.name)
        }
      })
      .sort((a, b) => a.order - b.order)
  }
  return weatherTypes
}

export const getSFDILevels = async (): Promise<BufferCalculationType[]> => {
  let allTypes: BufferCalculationType[] = await ky.get(URI, { hooks: cacheHook('session') }).json()
  allTypes = allTypes.filter((type) => type.calculationCategory.name === 'SFDI')

  return allTypes
}
